module.exports = __webpack_public_path__ + "static/img/2.6ebd6dc1.png";